import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowTags from './components/FlowTags';

const FlowTagsBridge = react2angular(FlowTags, ['tagIds']);
export default FlowTagsBridge;
